<!-- =========================================================================================
    File Name: FormValidationMultipleRules.vue
    Description: Simple form validation
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card title="Edit Profile">
    <div class="mt-5">
      <form>
        <div class="vx-row lg:w-1/2 w-full mt-5">
          <div class="vx-col w-full lg:w-1/2">
            <label  class="text-sm">First Name</label >
            <vs-input
              data-vv-as="First Name"
              v-validate="'required|alpha'" name="fname" v-model="model.fname" class="w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('fname')">{{ errors.first('fname') }}</span>
          </div>

          <div class="vx-col w-full lg:w-1/2">
            <label  class="text-sm">Last Name</label >

            <vs-input
              data-vv-as="Last Name"
              v-validate="'required|alpha'" name="lname" v-model="model.lname"
                      class=" w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('lname')">{{ errors.first('lname') }}</span>
          </div>

          <div class="vx-col lg:w-1/2 w-full mt-5">
            <label  class="text-sm">Phone Number</label >

            <vs-input
              data-vv-as="Phone"

              v-validate="'required|numeric'"  name="phone" v-model="model.phone"
                      class=" w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
          </div>

          <div class="vx-col lg:w-1/2 w-full mt-5">
            <label  class="text-sm">Email</label >

            <vs-input
              data-vv-as="Email"

              v-validate="'required|email'" name="email" v-model="model.email"
                      class=" w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </div>
        </div>
        <vs-button type="filled" @click.prevent="submitForm" class="mt-5 block">Edit</vs-button>
      </form>
    </div>
  </vx-card>
</template>

<script>
  export default {
    name: 'ProfileForm',
    data() {
      return {
        model: {
          fname:'',
          lname:'',
          phone:'',
          email:'',
        },
        name: "",
        username: "",
        email: "",
        password: "",
        confirm_password: "",
      }
    },
    methods: {
      submitForm() {
        this.$validator.validateAll().then(async result => {
          if (result) {
            this.$vs.loading();
            try{
              this.model.name = this.model.fname + ' '+this.model.lname;
              await  this.$store.dispatch('updateUserInfo' , this.model);
              this.$vs.loading.close();
            }catch (e) {
              this.$vs.loading.close();
            }
          }
        })
      }
    },

    mounted(){
      this.model = this.$store.state.AppActiveUser;
    }
  }
</script>
